import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gen-pro-list',
  templateUrl: './gen-pro-list.component.html',
  styleUrls: ['./gen-pro-list.component.css']
})
export class GenProListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list/gen-pro-list.component.ts